import { useEffect, useState, useMemo } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";

import { transformFileToGB } from '@/utils/files';

import AppHeader from "../components/header/AppHeader";
import CardContent from "@/components/card/CardContent";

import api from "@/api/index";

import "@/styles/film-view.scss";

function FilmView() {
  const [film, setFilm] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [embedCode, setEmbedCode] = useState(null);

  const { id } = useParams();

  const fetchFilm = async () => {
    try {
      const response = await api.movie.get(id); // change for ID
      setFilm(response?.data?.data || null);
      setIframeUrl(response.data.data.iframe_url);
      setEmbedCode(response.data.data.embed_code);

    } catch (err) {
      console.error(err);
      setFilm(null);
      setIframeUrl(null);
      setEmbedCode(null);
      
    } finally {
      setIsLoading(false);
    }
  };

  const voiceovers = useMemo(() => {
    if(!film || !Array.isArray(film.voiceovers)) {
      return ''
    }    

    return film.voiceovers
      .map((voiceover) => {
        return voiceover.name
      })
      .join(', ')
  }, [film])

  const size = useMemo(() => {
    if(!film || !Array.isArray(film.voiceovers) || !film.voiceovers[0]) {
      return ''
    }

    return film.voiceovers[0]?.video_file?.size || '-'
  }, [film])

  const categories = useMemo(() => {
    if(!film || !Array.isArray(film.categories)) {
      return ''
    }

    return film.categories
      .map((category) => {
        return category.title
      })
      .join(', ')
  }, [film])

  useEffect(() => {
    fetchFilm();
  }, []);

  return (
    <div className="film-view">
      <AppHeader title="Предпросмотр видео" isLogout={true} link="/" />

      {isLoading && (
        <div className="film-view__loader">
          <Spin size="large" indicator={<LoadingOutlined />} />
        </div>
      )}

      {!isLoading && film !== null && (
        <div className="app-container">
          <div className="film-view__container">
            {embedCode && (
              <CardContent isPaddingTop={false} title={film.name || ''}>
                <div dangerouslySetInnerHTML={{ __html: embedCode }} />
              </CardContent>
            )}

            <CardContent title="Информация о файле">
              <div className="film-view__info">
                <div className="film-view__info__block">
                  <div className="film-view__info__label">Название:</div>
                  <div className="film-view__info__data">{film.name}</div>
                </div>
                <div className="film-view__info__block">
                  <div className="film-view__info__label">Озвучка:</div>
                  <div className="film-view__info__data">{ voiceovers }</div>
                </div>
                <div className="film-view__info__block">
                  <div className="film-view__info__label">Размер:</div>
                  <div className="film-view__info__data">{transformFileToGB(size) }</div>
                </div>
                <div className="film-view__info__block">
                  <div className="film-view__info__label">Категории:</div>
                  <div className="film-view__info__data">{ categories }</div>
                </div>
              </div>
            </CardContent>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilmView;
